


















import Vue from 'vue'
import { makeUniGoods } from '@/utils'

export default Vue.extend({
  props: {
    value: {
      type: Object,
      required: true,
    },
    noSales: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    goods() {
      return makeUniGoods(this.value)
    },
  },
})
